/**
 * Normalize ERP person id for comparisons with labor ticket / program event data.
 * @param {string|number|null|undefined} id
 * @returns {string|null}
 */
export function normalizePersonId(id) {
  if (id === null || id === undefined || id === '') {
    return null;
  }
  return String(id);
}

/**
 * Program events with an attached labor ticket are scoped to that ticket's person.
 * Events with no labor ticket yet remain visible so the operator can claim.
 * @param {Array<Record<string, unknown>>} events
 * @param {string|null} personId
 */
export function filterProgramEventsByPerson(events, personId) {
  if (!personId) {
    return events;
  }
  return events.filter((event) => {
    const lt = event.laborTicket;
    if (!lt) {
      return true;
    }
    return String(lt.personId ?? '') === personId;
  });
}
